import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import store from './store'

Vue.use(Router)
const hasAuthority = store.getters.hasAuthority
const hasAnyAuthority = store.getters.hasAnyAuthority

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: '/main'
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "user" */ './views/Login.vue'),
        },
        {
            path: '/main',
            component: () => import(/* webpackChunkName: "user" */ './views/MainPage.vue'),
            meta: {
                authorize: () => store.state.user !== null
            },
            children: [
                {
                    path: '',
                    component: () => import(/* webpackChunkName: "user" */ './views/MainIndex.vue')
                },
                {
                    path: 'section-admin',
                    component: () => import(/* webpackChunkName: "user" */ './views/SectionAdmin.vue'),
                    meta: {
                        authorize: () => hasAnyAuthority('P_后台_管理_栏目', 'P_前台_管理_栏目')
                    }
                },
                {
                    path: 'template-admin',
                    component: () => import(/* webpackChunkName: "user" */ './views/TemplateAdmin.vue'),
                    meta: {
                        authorize: () => hasAnyAuthority('P_后台_管理_模板', 'P_前台_管理_模板')
                    }
                },
                {
                    path: 'edit-template/:id',
                    component: () => import(/* webpackChunkName: "user" */ './views/EditTemplate.vue'),
                    props: true,
                    meta: {
                        authorize: () => hasAnyAuthority('P_后台_管理_模板', 'P_前台_管理_模板')
                    }
                },
                {
                    path: 'preview-template/:id',
                    component: () => import(/* webpackChunkName: "user" */ './views/PreviewTemplate.vue'),
                    props: true,
                    meta: {
                        authorize: () => hasAnyAuthority('P_后台_管理_模板', 'P_前台_管理_模板')
                    }
                },
                {
                    path: 'portal-admin',
                    component: () => import(/* webpackChunkName: "user" */ './views/PortalAdmin.vue'),
                    meta: {
                        authorize: () => hasAuthority('P_前台_管理_门户')
                    }
                },
                {
                    path: 'portal-config/:id',
                    component: () => import(/* webpackChunkName: "user" */ './views/PortalConfig.vue'),
                    props: true,
                    meta: {
                        authorize: () => hasAuthority('P_前台_管理_门户')
                    }
                },
                {
                    path: 'portals/:id',
                    component: () => import(/* webpackChunkName: "user" */ './views/Portal.vue'),
                    props: true
                },
                {
                    path: 'project-admin',
                    component: () => import(/* webpackChunkName: "user" */ './views/ProjectAdmin.vue'),
                    meta: {
                        authorize: () => hasAuthority('P_后台_管理_项目')
                    }
                },
                {
                    path: 'datasource-config-admin',
                    component: () => import(/* webpackChunkName: "admin" */ './views/DatasourceConfigAdmin.vue'),
                    meta: {
                        authorize: () => hasAuthority('P_后台_管理_系统')
                    }
                },
                {
                    path: 'view-style-admin',
                    component: () => import(/* webpackChunkName: "admin" */ './views/ViewStyleAdmin.vue'),
                    meta: {
                        authorize: () => hasAuthority('P_后台_管理_样式模板')
                    }
                },
                {
                    path: 'user-profile',
                    component: () => import(/* webpackChunkName: "user" */ './views/UserProfile.vue')
                },
                {
                    path: 'user-admin',
                    component: () => import(/* webpackChunkName: "admin" */ './views/AdminUser.vue'),
                    meta: {
                        authorize: () => hasAnyAuthority('P_后台_管理_系统', 'P_前台_管理_系统')
                    }
                },
                {
                    path: 'usergroup-admin',
                    component: () => import(/* webpackChunkName: "admin" */ './views/UserGroupAdmin.vue'),
                    meta: {
                        authorize: () => hasAnyAuthority('P_后台_管理_系统', 'P_前台_管理_系统')
                    }
                },
                {
                    path: 'role-admin',
                    component: () => import(/* webpackChunkName: "admin" */ './views/RoleAdmin.vue'),
                    meta: {
                        authorize: () => hasAnyAuthority('P_后台_管理_系统', 'P_前台_管理_系统')
                    }
                },
                {
                    path: 'user-log-admin',
                    component: () => import(/* webpackChunkName: "admin" */ './views/AdminUserLog.vue'),
                    meta: {
                        authorize: () => hasAuthority('P_后台_管理_系统')
                    }
                },
                {
                    path: 'news-section/more',
                    component: () => import(/* webpackChunkName: "user" */ './views/sections/NewsSectionDataList.vue')
                },
                {
                    path: 'news-section/details',
                    component: () => import(/* webpackChunkName: "user" */ './views/sections/NewsSectionDataDetails.vue')
                },
                {
                    path: 'stat-section/news-list',
                    component: () => import(/* webpackChunkName: "user" */ './views/sections/StatSectionNewsList.vue')
                },
                {
                    path: 'news-details',
                    component: () => import(/* webpackChunkName: "user" */ './views/sections/NewsDetails.vue')
                },
                {
                    path: 'data-admin',
                    component: () => import(/* webpackChunkName: "admin" */ './views/DataAdmin.vue'),
                    meta: {
                        authorize: () => hasAnyAuthority('P_后台_管理_数据', 'P_前台_管理_数据')
                    }
                },
                {
                    path: 'etl-jobs',
                    component: () => import(/* webpackChunkName: "admin" */ './views/EtlJobAdmin.vue'),
                    meta: {
                        authorize: () => hasAuthority('P_后台_管理_系统')
                    }
                },
                {
                    path: 'penalties/:id',
                    component: () => import(/* webpackChunkName: "user" */ './views/Penalty.vue'),
                    props: true
                },
                {
                    path: 'company-alarm-news/:id',
                    component: () => import(/* webpackChunkName: "user" */ './views/CompanyAlarmNews.vue'),
                    props: true
                },
                {
                    path: 'companies/:id',
                    component: () => import(/* webpackChunkName: "user" */ './views/Company.vue'),
                    props: true
                },
                {
                    path: 'company-risk-events/:id',
                    component: () => import(/* webpackChunkName: "user" */ './views/CompanyRiskEvent.vue'),
                    props: true
                },
            ]
        },
        {
            path: '*',
            component: NotFound
        }
    ]
})
async function checkRouteAuthorize (to) {
    for (const record of to.matched) {
        if (record.meta.authorize) {
            const result = await record.meta.authorize()
            if(!result){
                return false
            }
        }
    }
    return true
}
router.beforeEach((to, from, next) => {
    checkRouteAuthorize(to).then(result=>{
        if(result){
            next()
        }else{
            if(store.state.user === null){
                store.dispatch('fetchUser').then(()=>{
                    checkRouteAuthorize(to).then(result=>{
                        if(result){
                            next()
                        }else{
                            next('/')
                        }
                    })
                }).catch(next)
            }else{
                next('/')
            }
        }
    }).catch(next)
})
export default router
